import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class PromoBboxJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.PROMO_BBOX;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.BELOW_THE_LINE_WEB;
    protected readonly wordings = {
        mainTitle: 'Une offre rien que pour vous\u00A0!',
        noFiber: 'Une offre rien que pour vous\u00A0!',
        results: {
            [TECHNOLOGY.FTTH]: "Vous êtes bien éligible à l'offre\u00A0!",
        },
    };
    protected readonly tracking = {
        page: 'Eligibilite_test_btl',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_btl',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_btl',
            nomClic: 'Ok',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_btl',
            nomClic: 'Eligibilite_ko_btl',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly cookieKey = 'BTL_WEB';
}
